var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-expansion-panels',_vm._l((_vm.machinewiseParts),function(rec,key){return _c('v-expansion-panel',{key:key,staticClass:"elevation-0"},[_c('v-expansion-panel-header',[_vm._v(" "+_vm._s(key)+" ")]),_c('v-expansion-panel-content',[_c('record',{attrs:{"list":rec,"title":key}})],1)],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }